module.exports = __webpack_public_path__ + "static/img/agco-logo.6911dec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/agco-logo.svg
// module id = svd0
// module chunks = 1